import request from "axios";

/**
 * 分页查询合伙人收益记录
 * @param {Object} params 查询参数 { current, size, startTime, endTime, keyword, orderType, settlementStatus }
 * @returns {Promise}
 */
export const getPartnerIncomeLogList = (params) => {
  return request({
    url: "/lebo-report/web/partner/manage/revenue/list",
    method: "get",
    params
  });
};

/**
 * 导出合伙人收益记录
 * @param {Object} params 查询参数 { startTime, endTime, keyword, orderType, settlementStatus }
 * @returns {Promise}
 */
export const exportPartnerIncomeLog = (params) => {
  return request({
    url: "/lebo-report/web/partner/manage/revenue/export",
    method: "get",
    params,
    responseType: "blob"
  });
};

